
const customAreas = [
	{
		id: 'example-area',
		name: 'Eksempel',
		background: 'research',
		infoTitle: 'Eksempel',
		infoText: `Dette er et eksempel på et custom område.`,
		tasksData: require('./tasks/example-area-tasks').tasksData,
		routes: [
			{
				id: 1,
				title: 'Case 1',
				subtitle: 'Lorem ipsum',
				text: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
			},
			{
				id: 2,
				title: 'Case 2',
				subtitle: 'Lorem ipsum',
				text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
			},
			{
				id: 3,
				title: 'Case 3',
				subtitle: 'Lorem ipsum',
				text: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`
			},
		] 
	}
];

export {
	customAreas
};